import { render, staticRenderFns } from "./PromotionProductsTable.vue?vue&type=template&id=050f7b02&scoped=true"
import script from "./PromotionProductsTable.vue?vue&type=script&lang=js"
export * from "./PromotionProductsTable.vue?vue&type=script&lang=js"
import style0 from "./PromotionProductsTable.vue?vue&type=style&index=0&id=050f7b02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050f7b02",
  null
  
)

export default component.exports